
// Main export file for the armpit health basics article data
import { armpitHealthBasicsMetadata } from './metadata';
import { armpitHealthBasicsContent } from './content';
import { armpitHealthBasicsSources } from './sources';
import { armpitHealthBasicsRecommendedProducts } from './recommended-products';
import { armpitHealthBasicsRelatedArticles } from './related-articles';

export const armpitHealthBasicsArticle = {
  ...armpitHealthBasicsMetadata,
  content: armpitHealthBasicsContent,
  sources: armpitHealthBasicsSources,
  recommendedProducts: armpitHealthBasicsRecommendedProducts,
  relatedArticles: armpitHealthBasicsRelatedArticles
};
